import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { Button } from "@whoosh/design-system/src/components/controls";
import { CloseIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import { ClubLogo } from "../../../components/ClubLogo/ClubLogo";
import { EventSignupSummaryHeader_event$key } from "./__generated__/EventSignupSummaryHeader_event.graphql";

type Props = {
  fragmentRef: EventSignupSummaryHeader_event$key;
  handleGoBack: () => void;
};

export const EventSignupSummaryHeader = ({
  fragmentRef,
  handleGoBack,
}: Props) => {
  const data = useFragment(EventSignupSummaryHeaderFragment, fragmentRef);

  const club = data.eventSeries.facility?.club ?? null;
  const clubName = club?.name;

  return (
    <HStack
      justifyContent="space-between"
      alignItems="center"
      padding={5}
      gap={4}
      testID="event-signup-summary-header"
    >
      <Box width={56} height={56}>
        <Button
          variant="secondary"
          onPress={handleGoBack}
          leftIcon={<CloseIcon />}
          accessibilityLabel={t`Close button`}
          testID="event-signup-summary-close-button"
        />
      </Box>

      <VStack flex={1} alignItems="center" justifyContent="center">
        {clubName ? (
          <Text
            variant="mainTiny"
            color="text-secondary"
            textAlign="center"
            numberOfLines={1}
          >
            {clubName}
          </Text>
        ) : null}
        <Text
          variant="mainBaseSemiBold"
          color="text-primary"
          textAlign="center"
        >
          {t`Signup Detail`}
        </Text>
      </VStack>

      <Box width={56} height={56}>
        <ClubLogo clubRef={club ?? null} />
      </Box>
    </HStack>
  );
};

export const EventSignupSummaryHeaderFragment = graphql`
  fragment EventSignupSummaryHeader_event on Event {
    eventSeries {
      facility {
        club {
          name
          ...ClubLogo_Club
        }
      }
    }
  }
`;
